/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessApiKeyDto } from '../models/BusinessApiKeyDto';
import type { BusinessApiKeyScopesResponseDto } from '../models/BusinessApiKeyScopesResponseDto';
import type { BusinessApiKeysListResponseDto } from '../models/BusinessApiKeysListResponseDto';
import type { CreateBusinessApiKeyDto } from '../models/CreateBusinessApiKeyDto';
import type { CreateBusinessApiKeyResponseDto } from '../models/CreateBusinessApiKeyResponseDto';
import type { RotateBusinessApiKeyDto } from '../models/RotateBusinessApiKeyDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApiKeysService {
    /**
     * List the scopes an API key can be granted
     * @returns BusinessApiKeyScopesResponseDto
     * @throws ApiError
     */
    public static apiKeysControllerGetScopesV1(): CancelablePromise<BusinessApiKeyScopesResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/api-keys/scopes',
        });
    }
    /**
     * Create an API key for the current business
     * @param requestBody
     * @returns CreateBusinessApiKeyResponseDto
     * @throws ApiError
     */
    public static apiKeysControllerCreateV1(
        requestBody: CreateBusinessApiKeyDto,
    ): CancelablePromise<CreateBusinessApiKeyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/api-keys',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List the current business's API keys
     * @returns BusinessApiKeysListResponseDto
     * @throws ApiError
     */
    public static apiKeysControllerListV1(): CancelablePromise<BusinessApiKeysListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/api-keys',
        });
    }
    /**
     * Revoke an API key (kept for audit, never deleted)
     * @param keyId
     * @returns BusinessApiKeyDto
     * @throws ApiError
     */
    public static apiKeysControllerRevokeV1(
        keyId: string,
    ): CancelablePromise<BusinessApiKeyDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/api-keys/{keyId}',
            path: {
                'keyId': keyId,
            },
        });
    }
    /**
     * Rotate an API key
     * Mints a replacement with the same name and scopes. The old key keeps working for 24h unless `immediate` is set.
     * @param keyId
     * @param requestBody
     * @returns CreateBusinessApiKeyResponseDto
     * @throws ApiError
     */
    public static apiKeysControllerRotateV1(
        keyId: string,
        requestBody: RotateBusinessApiKeyDto,
    ): CancelablePromise<CreateBusinessApiKeyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/api-keys/{keyId}/rotate',
            path: {
                'keyId': keyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
